import * as React from 'react';
import { Typography } from '../Typography';
import { createLocators } from '@u1/locators';
import clsx from 'clsx';
import useStyles from './Bubble.styles';

export interface IBubbleProps {
  /**
   * Text to be rendered
   */
  children: React.ReactNode;
  /**
   * Bubble position variant
   * @default single
   */
  position?: 'single' | 'top' | 'center' | 'bottom';
  /**
   * Bubble appearance option, which render Interlocutor bubble or Your own
   * @default false (Interlocutor bubbles)
   */
  isMy?: boolean;
}

export const bubbleLocators = createLocators({
  name: 'Bubble',
  componentLocators: ['bubble'],
});
const { locators } = bubbleLocators();

const Bubble: React.FC<IBubbleProps> = ({
  children,
  isMy,
  position = 'single',
}) => {
  const classes = useStyles();

  return (
    <Typography
      locatorsOverrides={locators.bubble({ position, isMy })}
      as="div"
      className={clsx(classes.root, classes[position], {
        [classes.my]: isMy,
      })}
    >
      {children}
    </Typography>
  );
};

export default Bubble;
